import { RentalManagerUserInfoV2WebApiHandler_get_queryOptions } from '@zg-rentals/ts-rental-manager-api-beta-client-react-query';
import { defineAuthProvider } from '@zg-rentals/auth-react';
import { getClient } from '@zg-rentals/ts-client-http-client';
import { isAuthorized } from '@zg-rentals/auth-comet';

import { BASE_URL } from './constants/urls';

const httpClient = getClient().extend({ prefixUrl: BASE_URL });

export const Auth = defineAuthProvider({
  queryOptions: () =>
    RentalManagerUserInfoV2WebApiHandler_get_queryOptions(
      {
        pageWithSensitiveInformation: true,
      },
      { httpClient },
    ),

  isAuthorized: isAuthorized({
    mapUser: (user) => ({ ...user, isLoggedIn: user.loggedIn }),
    requireStrongAuthentication: true,
  }),
});

export const { useAuth } = Auth;
